import * as React from "react";

export interface IRowProps {}

const Row: React.StatelessComponent<IRowProps> = ({ children }) => <div className="row">{children}</div>;

export default Row;
